import { Component, Injectable, Input, OnInit } from '@angular/core';
import { ShipmentEditComponent } from '../shipment-edit/shipment-edit.component';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { NavigationExtras, Router, RouterModule } from '@angular/router'
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { I18nModule, TranslationService } from '@spartacus/core';


@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}
@Component({
    selector: 'app-shipment-confirmation',
    imports: [CommonModule, FormsModule, I18nModule],
    templateUrl: './shipment-confirmation.component.html',
    styleUrl: './shipment-confirmation.component.scss',
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ]
})
export class ShipmentConfirmationComponent implements OnInit {
  checkCustomClearenceFlag: boolean = false;
  //checkDischargeCompletedFlag: boolean = false;
  enableLoader: boolean = false;
  @Input() shipData: any;
  @Input() converteddates: any;
  @Input() fromscreen: any;
  @Input() stockPileLocation: any;
  @Input() checkDischargeCompletedFlag:boolean;

  form: UntypedFormGroup;
  selectYear: any;
  selectMonth: any;
  nextMonth: any;
  preMonth: any;
  SubstartDateClearence: NgbDate = null;
  clearenceconvertedDate: any;
  clearenceDateTemp: any;
  section:any;
  constructor(public ActiveModal: NgbActiveModal,
    public modalService: NgbModal,
    public toastrService: ToastrService, private router: Router, public customprofile: CustomProfileService,public translation: TranslationService) { }


  ngOnInit(): void {
    console.log('rin confirm-->',this.shipData)
    this.clearenceDateTemp = this.shipData.clearenceDate;
     if(this.router.url.includes('portside')){
      this.section = 'portside';
     } else if(this.router.url.includes('bondedwarehouse')){
      this.section = 'bondedwarehouse';
     }
  }

  setTitle(value) {
    switch (value) {
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default: return;
    }
  }

  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for (let i = 0; i < element3.length; i++) {
      let value = element3[i].getAttribute("title");
      element3[i].setAttribute("title", this.setTitle(value));
    }

    let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
    for (let i = 0; i < element4.length; i++) {
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title", this.setTitle(value))
    }
  }
  checkPad(d) {
    return (d < 10) ? '0' + d.toString() : d?.toString();
  }
  clearenceDateSelection(selectedDate) {
    this.SubstartDateClearence = selectedDate;

    if (this.SubstartDateClearence != null) {
      this.clearenceconvertedDate = this.SubstartDateClearence.year + '-' + this.checkPad(this.SubstartDateClearence.month) + '-' + this.checkPad(this.SubstartDateClearence.day);
      this.shipData.clearenceDate = moment(this.clearenceconvertedDate).format('MM/DD/YYYY');
    }
  }

  close(shipData: any) {
    this.ActiveModal.close(shipData);
  }
  backToEdit() {
    const ModalRef = this.modalService.open(ShipmentEditComponent, { centered: true, size: 'md' });
    ModalRef.componentInstance.shipData = this.shipData;
    ModalRef.componentInstance.fromscreen = this.fromscreen
    ModalRef.componentInstance.section = this.section;
    this.close(this.shipData);
  }


  checkCustomClearence(flag) {
    if (flag == 'no') {
      this.checkCustomClearenceFlag = false;
      this.shipData.isCustomCleared = false;

    } else {
      this.checkCustomClearenceFlag = true;
      this.shipData.isCustomCleared = true;

    }
  }

  checkDischargeCompleted(flag) {
    if (flag == 'no') {
      this.checkDischargeCompletedFlag = false;
     // this.shipData.isDischarged = false;
    } else {
      this.checkDischargeCompletedFlag = true;
     // this.shipData.isDischarged = true;
    }
  }
  save() {
    let SaveObject = new Object({
      'isDischarged': this.checkDischargeCompletedFlag,
      'eta': this.convertDate(this.converteddates.etaconvertedDate, this.shipData.etaTime),
      'etb': this.convertDate(this.converteddates.etbconvertedDate, this.shipData.etbTime),
      'etcd': this.convertDate(this.converteddates.etcdconvertedDate, this.shipData.etcdTime),
      'etsd': this.convertDate(this.converteddates.etsdconvertedDate, this.shipData.etsdTime),     
      'stockPileLocation': this.shipData.stockPileLocation,
      'nominationNumber': this.shipData.nominationNumber,
      'nominationKey': this.shipData.nominationKey,
      'nominationItemNumber': this.shipData.nominationItemNumber,
      'eblConfirmation': this.shipData.eblConfirmation      
    })
    if(this.section === 'portside'){
      SaveObject['isCustomCleared'] = this.shipData.isCustomCleared;
      SaveObject['customClearedOn'] = this.convertDate(this.converteddates.clearenceconvertedDate, '00:00');
    this.callSaveAction(SaveObject);
    }else if(this.section === 'bondedwarehouse'){
       this.callSaveAction(SaveObject);
    }      
  }
  callSaveAction(SaveObject){
    this.enableLoader = true;
     let toastshown = false;
    this.customprofile.saveShipmentDetails(SaveObject).subscribe((response: any) => {
      if (response) {
        this.enableLoader = false;
        console.log(response);
        this.close(SaveObject);
        if (this.fromscreen == 'details') {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/shipmentvms/vmsdetails/' + this.shipData.nominationNumber+'/' + this.section], { queryParams: { nominationItemNumber: this.shipData.nominationItemNumber, nominationKey: this.shipData.nominationKey, fromscreen: this.fromscreen } });
          });
        }
        else if (this.fromscreen == 'list') {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/shipmentvms/shipmentvmslist/' + this.section])
          });
        }

      }
      else {
        this.enableLoader = false;
        // this.toastrService.show('Response not returned from commerce, please contact support team');
        this.translation.translate('shipment.emptyerrormessage').subscribe(res=>{   
          if(!toastshown){
            this.toastrService.show(res);
            toastshown=true;
          }
        })
      }
    }, err => {
      this.enableLoader = false;
      this.translation.translate('shipment.erroroccuredmessage').subscribe(res=>{   
        if(!toastshown){
          this.toastrService.show(res);
          toastshown=true;
        }
      })
     // this.toastrService.show('Error while saving the data, please contact support team');
    })
  }

  convertDate(date, time?) {
    const dateTime = time ? moment(date).format('DD/MM/YYYY') + ' - ' + time : moment(date).format('DD/MM/YYYY');
    return dateTime;
  }

}


